import React from "react";
import { useDispatch } from "react-redux";
import { setPage } from "../../../store/slices/pageSlice";
import { setSelectedPromo } from "../../../store/slices/selectedPromoSlice";
import PromosApi from "../../../api/PromosApi";

export default function Drop({ drop }) {
    const dispatch = useDispatch();

    // Проверяем наличие токена: если нет объекта ИЛИ нет logoUrl — это onlyCrystals
    const hasToken = drop?.token && drop?.token?.logoUrl;
    const gemImageUrl = drop?.gem?.frontImage 
        ? 'https://api.duotetra.quest/uploads/gems/' + drop.gem.frontImage 
        : null;

    // При клике на дроп — загружаем полные данные промо и открываем CompletedPromoLayout
    const handleClick = async () => {
        const promoId = drop?.promoId || drop?.promo?.id;
        if (!promoId) return;
        
        try {
            // Всегда загружаем полные данные промо (в дропе только краткая информация)
            const promo = await PromosApi.getById(promoId);
            if (promo) {
                dispatch(setSelectedPromo(promo));
                dispatch(setPage({ id: 8, name: 'CompletedPromo' }));
            }
        } catch (err) {
            console.error('Failed to load promo for drop:', err);
        }
    };

    const Category = () => (
        <div className={'w-[132px] h-full flex flex-row items-center gap-[12px]'}>
            {gemImageUrl ? (
                <img src={gemImageUrl} className={`w-[55px] h-[40px] object-contain`}/>
            ) : (
                <div className="w-[55px] h-[40px]" />
            )}
            <span
                className={'w-[77px] text-[15px] text-[#EAEAEA] text-center flex flex-row items-center'}>{drop?.gem?.name}</span>
        </div>
    )

    const Reward = () => (
        <div className={'w-[89px] h-full flex flex-row items-center gap-[11px]'}>
            <span className={`w-[76px] h-full flex flex-row items-center justify-end text-[15px] text-[#EAEAEA]`}>
                {drop?.amount}
            </span>
            {hasToken ? (
                <img 
                    src={drop.token.logoUrl} 
                    className={`w-[20px] h-[20px] rounded-full`}
                />
            ) : gemImageUrl ? (
                <img 
                    src={gemImageUrl} 
                    className={`w-[20px] h-[20px] object-contain`}
                />
            ) : (
                <div className="w-[20px] h-[20px] rounded-full bg-[#404040]" />
            )}
        </div>
    )

    return (
        <div
            onClick={handleClick}
            className={`w-full h-[45px] flex flex-row justify-between items-center pl-[11px] gap-[12px] bg-[#262626] rounded-[23px] px-[10px] cursor-pointer active:bg-[#333333] transition-colors`}
        >
            <Category/>

            <span className="text-[15px] text-[#EAEAEA] text-center flex flex-row items-start">
                {Number(drop?.chance?.positionChance ?? 0).toFixed(2)} %
            </span>

            <Reward/>
        </div>
    )
}
